import CartSizeTooltip from "./CartSizeTooltip";

export default CartSizeTooltip;
